import { render, staticRenderFns } from "./OwalListRow.vue?vue&type=template&id=68b78847&scoped=true"
import script from "./OwalListRow.vue?vue&type=script&lang=js"
export * from "./OwalListRow.vue?vue&type=script&lang=js"
import style0 from "./OwalListRow.vue?vue&type=style&index=0&id=68b78847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b78847",
  null
  
)

export default component.exports